export default __webpack_public_path__ + "static/media/Welcome.44b2245e.png";